import {
    ComponentFactoryResolver,
    Injectable,
    Inject,
    ComponentRef,
    ViewContainerRef,
} from '@angular/core';
import { ToasterComponent } from './toaster.component';

@Injectable()
export class ToasterService {
    private factoryResolver: ComponentFactoryResolver;
    private rootViewContainer: ViewContainerRef;
    private lastComponent: ComponentRef<ToasterComponent>;
    private lastComponentTimeout;

    constructor(@Inject(ComponentFactoryResolver) factoryResolver) {
        this.factoryResolver = factoryResolver;
    }

    setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
        this.rootViewContainer = viewContainerRef;
    }

    success(message?: string) {
        if (!message) {
            message = 'Réussi!';
        }
        this.addToast(message, true, false);
    }

    error(message?: string) {
        if (!message) {
            message = 'Erreur';
        }
        this.addToast(message, false, true);
    }

    private addToast(message: string, success: boolean, error: boolean) {
        if (this.lastComponentTimeout) {
            clearTimeout(this.lastComponentTimeout);
            this.lastComponentTimeout = null;
        }
        if (this.lastComponent) {
            this.lastComponent.destroy();
            this.lastComponent = null;
        }

        const factory =
            this.factoryResolver.resolveComponentFactory(ToasterComponent);
        const component: ComponentRef<ToasterComponent> = factory.create(
            this.rootViewContainer.parentInjector
        );

        component.instance.message = message;
        component.instance.isSuccess = success;
        component.instance.isError = error;

        this.rootViewContainer.insert(component.hostView);

        this.lastComponentTimeout = setTimeout(() => {
            this.lastComponentTimeout = null;
            if (this.lastComponent) {
                this.lastComponent.destroy();
                this.lastComponent = null;
            }
        }, 5000);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/toaster/toaster.service.ts